export enum PlatformStatus {
  SIMPLE,
  VIP,
  GOLD,
}
